import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { IHowdenEnvironment, IPackageJsonWrapper, provideHowdenCore } from '@howdeniberia/core-front';
import { provideClientSearchLib } from 'clients-search-lib';
import packageJson from '../../package.json';
import { ApiConfigurations } from '../environments/api-configurations';
import { environment } from '../environments/environment';
import { AppRoutes } from './app-routing';

export const appConfig: ApplicationConfig = {
  providers: [
    provideClientSearchLib(),
    provideRouter(AppRoutes),
    provideHowdenCore({
      environment: environment as IHowdenEnvironment,
      packageJson: packageJson as unknown as IPackageJsonWrapper,
      apiConfigurations: ApiConfigurations
    })
  ]
};
